import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { ErrorPage } from 'axway-react-ui';

class NotFoundView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		return (
			<ErrorPage
				modal={!!this.props.modal}
				imgClass="gg icon-GG-cloud-alert"
				errorDetail={{ action: 'notfound', status: 404 }}
			/>
		);
	}
}

NotFoundView.propTypes = {
	modal: PropTypes.bool
};

NotFoundView.defaultProps = {
	modal: false
};

export default injectIntl(NotFoundView);
